import api from '@api/Api';

export default {

    getMessages(params) {
        return api().get(`/messages`, { params: params });
    },

    getMessagesStats(params) {
        return api().get(`/messages/stats`, { params: params });
    },

    unsubscribe(id, params) {
        return api().post(`/messages/${id}/unsubscribe`, params);
    },

    resubscribe(id, params) {
        return api().post(`/messages/${id}/resubscribe`, params);
    },

}
